import { prefixer } from "stylis";

import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";

export const createRtlCache = (isRtl) =>
  createCache({
    key: isRtl ? "muirtl" : "mui",
    stylisPlugins: isRtl ? [prefixer, rtlPlugin] : [],
  });
